import styled from 'styled-components';
import 'react-day-picker/lib/style.css';
import { black, blue, grey, red, hoverBlue, lightGray } from '../../assets/ui/colors';


export const MainContainer = styled.div`
    display: flex;
    margin: -16px;
`;

export const ScheduleContainer = styled.div`
    margin: 16px;
    border: 1px solid #C5C6C6;
    border-radius: 4px;
    padding: 28px 26px 0 26px;
    text-align: center;
    background: white;
    position: relative;
    @media (max-width: 400px) {
        padding: 12px 0px 0 0px;
    }
    & .DayPicker {
        width: -webkit-fill-available;
        width: -moz-available;
        width: fill-available;
        font-size: 16px;
        & .DayPicker-wrapper {
            outline: 0 !important;
            & :focus {
                outline: 0 !important;
            }
            & .DayPicker-NavBar {
                & .DayPicker-NavButton--prev {
                    top: 0;
                    left: 0;
                }
                & .DayPicker-NavButton--next {
                    top: 0;
                    right: 0;
                }
            }
            & .DayPicker-Months {
                & .DayPicker-Month {
                    display: flex;
                    flex-direction: column;
                    width: -webkit-fill-available;
                    width: -moz-available;
                    width: fill-available;
                    align-items: center;
                    margin: 0;
                    & .DayPicker-Caption {
                        & div {
                            font-family: OpenSans !important;
                            text-align: center;
                            margin-bottom: 20px;
                            font-weight: 600;
                            line-height: 21px;
                            letter-spacing: 0.1px;
                        }
                    }
                    & .DayPicker-Weekdays {
                        display: flex;
                        width: -webkit-fill-available;
                        width: -moz-available;
                        width: fill-available;
                        & .DayPicker-WeekdaysRow {
                            display: flex;
                            justify-content: space-between;
                            width: -webkit-fill-available;
                            width: -moz-available;
                            width: fill-available;
                            & .DayPicker-Weekday {
                                width: 36px;
                                color: ${grey};
                                font-size: 12px;
                                line-height: 15px;
                                align-items: center;
                                text-align: center;
                                letter-spacing: 0.4px;
                                padding: 0;
                                height: 24px;
                                margin: 9px;
                                @media (max-width: 490px) {
                                    margin: 2px;
                                }
                            }
                        }
                    }
                    & .DayPicker-Body {
                        display: flex;
                        flex-direction: column;
                        width: -webkit-fill-available;
                        width: -moz-available;
                        width: fill-available;
                        & .DayPicker-Week {
                            display: flex;
                            justify-content: space-between;
                            line-height: 20px;
                            text-align: center;
                            letter-spacing: 0.304536px;
                            color: ${grey};
                            & .DayPicker-Day {
                                position: relative;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                width: 36px;
                                height: 36px;
                                padding: 0;
                                margin: 9px;
                                @media (max-width: 490px) {
                                    margin: 2px;
                                }
                                & ::before {
                                    content: "";
                                    display: inline-block;
                                    vertical-align: middle;
                                    padding-top: 100%;
                                }
                            }
                            & .DayPicker-Day--today {
                                color: ${blue};
                            }
                            & .DayPicker-Day--selected {
                                background: ${lightGray};
                                color: ${black};
                            }
                            & .DayPicker-Day--highlighted {
                                background: ${hoverBlue};
                                color: white;
                            }
                            & .DayPicker-Day--myAppointments::after {
                                position: absolute;
                                left: calc(50% - 6px/2 + 19px);
                                top: calc(50% - 6px/2 - 16px);
                                border-radius: 50%;
                                content: "";
                                background-color: ${hoverBlue};
                                width: 6px;
                                height: 6px;
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const CellsContainer = styled.div`
    font-size: 16px;
    border: 1px solid #C5C6C6;
    border-radius: 4px;
    padding: 28px 42px 32px 42px;
    margin: 16px;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    height: calc(100% - 30px);
    background: white;
    & button {
        margin-top: auto;
        width: 200px;
    }
`;

export const CellsTitle = styled.div`
    font-weight: 600;
    font-size: 16px;
    line-height: 21px;
    text-align: center;
    letter-spacing: 0.1px;
    margin-bottom: 32px;
`;

export const Cells = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: -14px;
    margin-bottom: 32px;
    justify-content: space-around;
    width: -webkit-fill-available;
    width: -moz-available;
    width: fill-available;
`;

export const Cell = styled.div`
    background: ${props => props.isActive ? hoverBlue : '#f3f4f4'};
    color: ${props => props.isActive ? 'white' : black};
    border-radius: 20px;
    padding: 10px 7px 7px 7px;
    line-height: 19px;
    letter-spacing: 0.25px;
    margin: 14px;
    cursor: pointer;
`;

export const AppointmentsList = styled.div`
    font-size: 16px;
    border: 1px solid #C5C6C6;
    border-radius: 4px;
    padding: 28px 42px 32px 42px;
    margin: 16px;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    background: white;
`;

export const AppointmentLabel = styled.div`
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 0.250795px;
    color: ${grey};
    text-align: left;
    margin-bottom: 8px;
`;

export const AppointmentTitle = styled.div`
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    text-align: left;
    margin-bottom: 24px;
`;

export const InfoText = styled.div`
    color: ${grey};
    margin: auto;
`;

export const NextBtn = styled.div`
    position: fixed;
    bottom: 0;
    right: 0;
    height: 64px;
    width: 145px;
    z-index: 13000;
    cursor: pointer;
    @media (max-width: 600px) {
        width: 100px;
    }
`;

export const CalendarLoader = styled.div`
position: absolute;
width: calc(100% - 52px);
height: 100%;
opacity: 0.5;
    & .MuiCircularProgress-root {
        margin: 25% 0;
    }
`;

export const WarningMessage = styled.div`
    margin: auto;
    margin-top: 200px;
    color: ${red};
    & a {
        color: ${blue};
    }
    @media (max-width: 600px) {
        margin-top: 24px;
    }
`;
